import { useEthers } from '@usedapp/core';
import { constants, utils } from 'ethers';
import networkMapping from '../chain-info/deployments/map.json';
import Memori from '../artifacts/contracts/Memori.sol/Memori.json';

export const useMemori = () => {
  const { chainId } = useEthers();
  const address = chainId
    ? networkMapping[String(chainId)].Memori[0]
    : constants.AddressZero;
  const abi = new utils.Interface(Memori.abi);
  return [address, abi, chainId];
};
